import { ApolloError } from "@apollo/client";
import {
  EnumLeadStatus,
  PeopleManySimpleQuery,
  SortFindManyPeopleInput,
} from "gql/generated";
import { createContext, Dispatch, SetStateAction } from "react";

export type Person = PeopleManySimpleQuery["peopleManySimple"][0];

export type PeopleContextValues = {
  searchPeople: (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    queryBuilder: Record<string, any> | null,
    sort: SortFindManyPeopleInput,
  ) => Promise<void>;
  fetchPage: (page: number) => Promise<void>;
  currentPage: number;
  people: Person[];
  updatePeople: Dispatch<SetStateAction<Person[]>>;
  peopleForPage: Person[];
  totalPeople: number;
  hasMore: boolean;
  initialLoad: boolean;
  error: ApolloError | undefined;
  peopleLoading: boolean;
  removeLeadByIdLoading: boolean;
  removeLeadById: (personId: string, leadId: string) => Promise<boolean>;
  updateLeadStatusByIdLoading: boolean;
  updateLeadStatusById: (
    personId: string,
    leadId: string,
    status: EnumLeadStatus,
  ) => Promise<boolean>;
  /** Re-run the last people search (same filters/sort). Use after mutations e.g. person delete so the directory list stays in sync. */
  refreshPeopleList: () => Promise<void>;
};

export const PeopleContext = createContext<PeopleContextValues | null>(null);
